import { VStack } from '@chakra-ui/react';
import { useWSysPage, useWSysPath } from "@coimbra-its/websys-ux-core";
import React from 'react';
import { SunBlock, SunButton, SunLinkButton, SunPage, SunStack } from "../components/Sun";
import { SunState, useSunStore } from '../store/sunSlice';
import { ADMINS } from '../web3/config';


export interface DashboardProps {
    walletBox: React.ReactNode;
}


export function Dashboard({ walletBox }: DashboardProps) {
    const path = useWSysPath();
    const page = useWSysPage({ title: 'SDBN3 & SDBN3+', maxCols: 2, onClosed: false })
    const connectedWallet = useSunStore((state: SunState) => state.connectedWallet);

    const isAdmin = connectedWallet && ADMINS.map(a => a.toLocaleUpperCase()).indexOf(connectedWallet.address.toUpperCase()) >= 0;

    return <SunPage page={page} >

        <SunStack>
            {walletBox}
            {!!connectedWallet && <>
                <SunLinkButton onClick={() => path.open('wallet')}>Wallet</SunLinkButton>
                <SunLinkButton onClick={() => path.open('withdraw_sdbn3')}>Withdraw SDBN3</SunLinkButton>
                {/*<SunLinkButton onClick={() => path.open('withdraw_sdbn3plus')}>Withdraw SDBN3+</SunLinkButton>*/}
            </>}
            {!!connectedWallet && isAdmin && <>
                <SunBlock header='Owner tools' >
                    <SunButton variant='outline' onClick={() => path.open('admin_payout_sdbn3')}>Payout SDBN3</SunButton>
                    {/*<SunButton variant='outline' onClick={() => path.open('admin_payout_sdbn3plus')}>Payout SDBN3+</SunButton>*/}
                </SunBlock>
            </>   
        }
        </SunStack>
    </SunPage >
}


